<template>
  <div>
    <v-dialog v-model="internalDialog" max-width="500px" scrollable>
      <v-overlay :value="overlayComponent">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-card class="text-center">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container>
          <v-card-text>
            <v-row>
              <v-col cols="6" class="text-left pt-10">
                <h3><strong>แก้ไขข้อมูล</strong></h3>
              </v-col>
              <v-col cols="6" class="pt-10">
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pt-0">
                <template v-if="BookingDataItemEdit">
                  <div
                    v-for="(item, index) in BookingDataItemEdit"
                    :key="index"
                  >
                    <template
                      v-if="
                        item.conditionField === '' ||
                          item.conditionField === null
                      "
                    >
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'text'"
                      >
                        <v-text-field
                          v-if="item.fieldName === 'เบอร์โทร'"
                          v-mask="'###-###-####'"
                          v-model="item.fieldValue"
                          :label="item.fieldName"
                          outlined
                          dense
                          required
                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                        ></v-text-field>
                        <v-text-field
                          v-else
                          v-model="item.fieldValue"
                          :label="item.fieldName"
                          outlined
                          dense
                          required
                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'number'"
                      >
                        <v-text-field
                          v-if="item.fieldName === 'เบอร์โทร'"
                          v-mask="'###-###-####'"
                          v-model="item.fieldValue"
                          :label="item.fieldName"
                          outlined
                          dense
                          required
                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                        ></v-text-field>
                        <v-text-field
                          v-else
                          v-model="item.fieldValue"
                          :label="item.fieldName"
                          outlined
                          dense
                          required
                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'dateTime'"
                      >
                        <v-menu
                          v-model="menuEdit1[item.fieldId]"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          :rules="[rules.required]"
                          transition="scale-transition"
                          offset-y
                          required
                          min-width="auto"
                          :ref="menuEdit1[item.fieldId]"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="item.fieldValue"
                              readonly
                              :label="item.fieldName"
                              outlined
                              dense
                              v-bind="attrs"
                              v-on="on"
                              required
                              prepend-inner-icon="mdi-calendar"
                              :rules="
                                item.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            >
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="item.fieldValue"
                            no-title
                            scrollable
                            @input="
                              (menuEdit1[item.fieldId] = false),
                                $refs.menuEdit1[item.fieldId].save(item.fieldValue)
                            "
                          >
                          </v-date-picker>
                        </v-menu>
                      </v-col>
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'Autocompletes'"
                      >
                        <v-autocomplete
                          v-model="item.fieldValue"
                          :items="JSON.parse(item.optionField)"
                          outlined
                          :label="item.fieldName"
                          required
                          dense
                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                        ></v-autocomplete>
                      </v-col>
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'Selects'"
                      >
                        <v-select
                          class="mb-6"
                          v-model="item.fieldValue"
                          :items="JSON.parse(item.optionField)"
                          menu-props="auto"
                          :label="item.fieldName"
                          required
                          :rules="
                            item.requiredField === 'True'
                              ? [rules.required]
                              : [true]
                          "
                          dense
                          clearable
                          outlined
                        ></v-select>
                      </v-col>
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'Radio'"
                        style="padding:0px;"
                      >
                        <v-container fluid style="padding:0px;">
                          <v-radio-group
                            column
                            dense
                            v-model="item.fieldValue"
                            style="margin:0px;"
                          >
                            <template v-slot:label> </template>
                            <div
                              v-for="radios in JSON.parse(
                                item.optionField
                              )"
                              :key="radios.toISOString"
                            >
                              <v-radio
                                :label="radios.text"
                                dense
                                :value="radios.value"
                              ></v-radio>
                            </div>
                          </v-radio-group>
                        </v-container>
                      </v-col>
                      <v-col
                        cols="12"
                        class="InputData"
                        v-if="item.fieldType == 'Checkbox'"
                        style="padding: 0;"
                      >
                        <div>
                          <p
                            style="
                              text-align: left;
                              display: block;
                              font-size: 16px;
                              margin-bottom: 10px;
                            "
                          >
                            {{ item.fieldName }}
                          </p>
                          <div
                            v-for="(checkbox, index) in JSON.parse(item.optionField)"
                            :key="checkbox.text"
                          >
                            <v-container
                              fluid
                              class="pa-0 pt-0"
                              :class="{
                                'mb-1': index !== JSON.parse(item.optionField).length - 1, // ระยะปกติ
                                'mb-5': index === JSON.parse(item.optionField).length - 1, // ตัวสุดท้าย
                              }"
                            >
                              <span style="display: none;">{{ item.fieldValue }}</span>
                              <v-checkbox
                                v-model="selected[item.fieldId]"
                                :label="languageSelect === 0 ? checkbox.text : checkbox.textEng"
                                :value="checkbox.value"
                                :rules="item.requiredField === 'True' ? [rules.checkBox] : [true]"
                                @click="item.fieldValue = JSON.stringify(selected[item.fieldId] || [])"
                                class="pt-1 mt-2 ps-3"
                              >
                              </v-checkbox>
                            </v-container>
                          </div>
                        </div>
                      </v-col>
                    </template>
                    <template
                      v-if="
                        item.conditionField !== '' &&
                          BookingDataItemEdit.filter(row => {
                            return (
                              row.fieldId ===
                              parseInt(item.conditionField)
                            );
                          }).length > 0
                      "
                    >
                      <template
                        v-if="
                          item.conditionValue ===
                            BookingDataItemEdit.filter(row => {
                              return (
                                row.fieldId ===
                                parseInt(item.conditionField)
                              );
                            })[0].fieldValue
                        "
                      >
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'text'"
                        >
                          <v-text-field
                            v-if="item.fieldName === 'เบอร์โทร'"
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            v-mask="'###-###-####'"
                            outlined
                            dense
                            required
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-text-field>
                          <v-text-field
                            v-else
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            outlined
                            required
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'number'"
                        >
                          <v-text-field
                            v-if="item.fieldName === 'เบอร์โทร'"
                            v-mask="'###-###-####'"
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            outlined
                            required
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-text-field>
                          <v-text-field
                            v-else
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            outlined
                            required
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'dateTime'"
                        >
                          <v-menu
                            v-model="menuEdit2[item.fieldId]"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            :rules="[rules.required]"
                            transition="scale-transition"
                            offset-y
                            required
                            min-width="auto"
                            :ref="menuEdit2[item.fieldId]"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="item.fieldValue"
                                readonly
                                :label="item.fieldName"
                                outlined
                                dense
                                prepend-inner-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                required
                                :rules="
                                  item.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="item.fieldValue"
                              no-title
                              scrollable
                              @input="
                                (menuEdit2[item.fieldId] = false),
                                  $refs.menuEdit2[item.fieldId].save(item.fieldValue)
                              "
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'Autocompletes'"
                        >
                          <v-autocomplete
                            v-model="item.fieldValue"
                            :items="JSON.parse(item.optionField)"
                            outlined
                            :label="item.fieldName"
                            required
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-autocomplete>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'Selects'"
                        >
                          <v-select
                            class="mb-6"
                            v-model="item.fieldValue"
                            :items="JSON.parse(item.optionField)"
                            menu-props="auto"
                            :label="item.fieldName"
                            required
                            dense
                            clearable
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'Radio'"
                          style="padding:0px;"
                        >
                          <v-container fluid style="padding:0px;">
                            <v-radio-group
                              row
                              dense
                              v-model="item.fieldValue"
                              :rules="
                                item.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                              style="margin:0px;"
                            >
                              <template v-slot:label> </template>
                              <div
                                v-for="radios in JSON.parse(
                                  item.optionField
                                )"
                                :key="radios.toISOString"
                              >
                                <v-radio
                                  :label="radios.text"
                                  :value="radios.value"
                                  dense
                                ></v-radio>
                              </div>
                            </v-radio-group>
                          </v-container>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'Checkbox'"
                          style="padding: 0;"
                        >
                          <div>
                            <p
                              style="
                                text-align: left;
                                display: block;
                                font-size: 16px;
                                margin-bottom: 10px;
                              "
                            >
                              {{ item.fieldName }}
                            </p>
                            <div
                              v-for="(checkbox, index) in JSON.parse(item.optionField)"
                              :key="checkbox.text"
                            >
                              <v-container
                                fluid
                                class="pa-0 pt-0"
                                :class="{
                                  'mb-1': index !== JSON.parse(item.optionField).length - 1, // ระยะปกติ
                                  'mb-5': index === JSON.parse(item.optionField).length - 1, // ตัวสุดท้าย
                                }"
                              >
                                <span style="display: none;">{{ item.fieldValue }}</span>
                                <v-checkbox
                                  v-model="selected[item.fieldId]"
                                  :label="languageSelect === 0 ? checkbox.text : checkbox.textEng"
                                  :value="checkbox.value"
                                  :rules="item.requiredField === 'True' ? [rules.checkBox] : [true]"
                                  @click="item.fieldValue = JSON.stringify(selected[item.fieldId] || [])"
                                  class="pt-1 mt-2 ps-3"
                                >
                                </v-checkbox>
                              </v-container>
                            </div>
                          </div>
                        </v-col>
                      </template>
                    </template>
                    <template v-if="item.conditionField === 'flow'">
                      <template
                        v-if="
                          parseInt(item.conditionValue) ===
                            parseInt(formEditBooking.flowId)
                        "
                      >
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'text'"
                        >
                          <v-text-field
                            v-if="item.fieldName === 'เบอร์โทร'"
                            v-mask="'###-###-####'"
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                          <v-text-field
                            v-else
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'number'"
                        >
                          <v-text-field
                            v-if="item.fieldName === 'เบอร์โทร'"
                            v-mask="'###-###-####'"
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                          <v-text-field
                            v-else
                            v-model="item.fieldValue"
                            :label="item.fieldName"
                            dense
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            outlined
                          ></v-text-field>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'dateTime'"
                        >
                          <v-menu
                            v-model="menuEdit3[item.fieldId]"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            :rules="[rules.required]"
                            transition="scale-transition"
                            offset-y
                            required
                            min-width="auto"
                            :ref="menuEdit3[item.fieldId]"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="item.fieldValue"
                                readonly
                                :label="item.fieldName"
                                outlined
                                dense
                                prepend-inner-icon="mdi-calendar"
                                v-bind="attrs"
                                v-on="on"
                                required
                                :rules="
                                  item.requiredField === 'True'
                                    ? [rules.required]
                                    : [true]
                                "
                              >
                              </v-text-field>
                            </template>
                            <v-date-picker
                              v-model="item.fieldValue"
                              no-title
                              scrollable
                              @input="
                                (menuEdit3[item.fieldId] = false),
                                  $refs.menuEdit3[item.fieldId].save(item.fieldValue)
                              "
                            >
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'Autocompletes'"
                        >
                          <v-autocomplete
                            v-model="item.fieldValue"
                            :items="JSON.parse(item.optionField)"
                            dense
                            filled
                            :label="item.fieldName"
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                          ></v-autocomplete>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType == 'Selects'"
                        >
                          <v-select
                            class="mb-6"
                            v-model="item.fieldValue"
                            :items="JSON.parse(item.optionField)"
                            menu-props="auto"
                            :label="item.fieldName"
                            dense
                            clearable
                            :rules="
                              item.requiredField === 'True'
                                ? [rules.required]
                                : [true]
                            "
                            hide-details
                            outlined
                          ></v-select>
                        </v-col>
                        <v-col
                          cols="12"
                          class="InputData"
                          v-if="item.fieldType === 'Radio'"
                          style="padding:0px;"
                        >
                          <v-container fluid style="padding:0px;">
                            <v-radio-group
                              row
                              v-model="item.fieldValue"
                              style="margin:0px;"
                              :rules="
                                item.requiredField === 'True'
                                  ? [rules.required]
                                  : [true]
                              "
                            >
                              <template v-slot:label> </template>
                              <div
                                v-for="radios in JSON.parse(
                                  item.optionField
                                )"
                                :key="radios.toISOString"
                                class="text-center"
                              >
                                <v-radio
                                  :label="radios.text"
                                  dense
                                  :value="radios.value"
                                ></v-radio>
                              </div>
                            </v-radio-group>
                          </v-container>
                        </v-col>
                      </template>
                    </template>
                  </div>
                </template>
              </v-col>
              <v-col cols="12" class="pt-0">
                <v-autocomplete
                  v-model="formEditBooking.empSelect"
                  :items="employeeAdminName"
                  label="พนักงานที่รับนัดหมาย"
                  outlined
                  dense
                  :rules="[rules.required]"
                ></v-autocomplete>
              </v-col>
            </v-row>
            <div class="text-center">
              <v-btn
                elevation="2"
                color="#173053"
                dark
                large
                block
                @click="editBooking()"
                >แก้ไขข้อมูล</v-btn
              >
            </div>
          </v-card-text>
        </v-container>
      </v-form>
    </v-card>
  </v-dialog>
  </div>
</template>

<script>
import axios from 'axios' // api
// import moment from 'moment'
export default {
  name: 'DialogEditBooking',
  components: {
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    dataEditBooking: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      languageSelect: 0,
      valid: true,
      rules: {
        numberRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        counterTel: value => value.length <= 10 || 'Max 10 characters',
        IDcardRules: value =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          'กรุณากรอกตัวเลข 0 ถึง 9',
        required: value => !!value || 'กรุณากรอก.',
        resizeImag: value =>
          !value ||
          value.size < 2000000 ||
          'Avatar size should be less than 2 MB!',
        counterIDcard: value => value.length <= 13 || 'Max 13 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      internalDialog: this.value,
      employeeAdminName: [],
      formEditBooking: {
        flowId: null,
        masBranchID: null,
        empSelect: ''
      },
      BookingDataItemEdit: [],
      overlayComponent: false,
      menuEdit1: [],
      menuEdit2: [],
      menuEdit3: [],
      selected: {}
    }
  },
  watch: {
    value (val) {
      this.internalDialog = val
      if (val) {
        this.clearData()
        this.formEditBooking.flowId = this.dataEditBooking.flowId
        this.formEditBooking.masBranchID = this.dataEditBooking.masBranchID
        this.getEmpAdmin(this.dataEditBooking)
        this.buildDataCustomField(this.dataEditBooking)
      }
    },
    internalDialog (val) {
      this.$emit('input', val) // sync กับ parent
    }
  },
  methods: {
    async clearData () {
      this.employeeAdminName = []
      this.formEditBooking = {
        flowId: null,
        masBranchID: null,
        empSelect: ''
      }
      this.BookingDataItemEdit = []
      this.overlayComponent = false
      this.menuEdit1 = []
      this.menuEdit2 = []
      this.menuEdit3 = []
      this.selected = {}
    },
    close () {
      this.internalDialog = false
    },
    async getEmpAdmin (item) {
      this.employeeAdminName = []
      await axios
        .get(
          this.$DNS_IP +
            '/empSelect/getUse?privacyPage=booking&shopId=' +
            item.shopId
        )
        .then(async response => {
          let rs = response.data
          if (rs.length > 0) {
            for (let i = 0; i < rs.length; i++) {
              let d = rs[i]
              if (d.masBranchID === item.masBranchID) {
                let s = {}
                s.text = d.empFirst_NameTH
                s.value = d.empId
                this.employeeAdminName.push(s)
              } else if (d.masBranchID === null || d.masBranchID === '') {
                let s = {}
                s.text = d.empFirst_NameTH
                s.value = d.empId
                this.employeeAdminName.push(s)
              }
            }
          }
        })
    },
    async buildDataCustomField (item) {
      try {
        this.BookingDataItemEdit = []
        let itemIncustomField = []
        await axios.get(this.$DNS_IP + '/BookingField/get?shopId=' + item.shopId)
          .then(async resBookingField => {
            let dataBookingField = resBookingField.data
            if (dataBookingField.length > 0) {
              let bookingData = []
              bookingData = JSON.parse(dataBookingField[0].flowfieldName)
              for (let i = 0; i < bookingData.length; i++) {
                let d = bookingData[i]
                itemIncustomField.push(d.fieldId)
              }
              await axios
                .get(
                  this.$DNS_IP +
                  '/customField/fieldId?fieldId=' +
                  itemIncustomField
                )
                .then(async resCustomField => {
                  let dataCustomField = resCustomField.data
                  await axios
                    .get(
                      this.$DNS_IP + '/BookingDataSelect/get?bookNo=' + item.bookNo
                    )
                    .then(async response => {
                      let rs = response.data
                      console.log('BookingDataSelect', rs)
                      if (rs.length > 0) {
                        let sortrs = dataCustomField.sort(
                          (a, b) => a.sortNoField - b.sortNoField
                        )
                        for (var i = 0; i < sortrs.length; i++) {
                          var d = sortrs[i]
                          var s = {}
                          var dataBD = rs.filter(el => {
                            return parseInt(el.fieldId) === parseInt(d.fieldId)
                          })
                          // console.log('dataBD', dataBD)
                          if (dataBD.length > 0) {
                            s.bookNo = dataBD[0].bookNo
                            s.bookingFieldId = dataBookingField[0].bookingFieldId
                            s.bookingDataId = dataBD[0].bookingDataId
                            s.conditionField = d.conditionField
                            s.fieldId = d.fieldId
                            s.fieldType = d.fieldType
                            if (d.fieldType === 'Checkbox') {
                              console.log('checkbox')
                              this.selected[d.fieldId] = this.parseCheckboxValue(dataBD[0].fieldValue)
                            }
                            s.fieldValue = dataBD[0].fieldValue
                            s.fieldName = d.fieldName
                            s.conditionField = d.conditionField
                            s.conditionValue = d.conditionValue
                            s.requiredField = d.requiredField
                            s.optionField = d.optionField
                            this.BookingDataItemEdit.push(s)
                          } else {
                            s.bookNo = rs[0].bookNo
                            s.bookingFieldId = dataBookingField[0].bookingFieldId
                            s.bookingDataId = 'newDataBooking'
                            s.conditionField = d.conditionField
                            s.fieldId = d.fieldId
                            s.fieldType = d.fieldType
                            s.fieldValue = s.fieldType === 'Checkbox' ? '[]' : ''
                            s.fieldName = d.fieldName
                            s.conditionField = d.conditionField
                            s.conditionValue = d.conditionValue
                            s.requiredField = d.requiredField
                            s.optionField = d.optionField
                            this.BookingDataItemEdit.push(s)
                          }
                        }
                      } else {
                        let sortrs = dataCustomField.sort(
                          (a, b) => a.sortNoField - b.sortNoField
                        )
                        for (let i = 0; i < sortrs.length; i++) {
                          let d = sortrs[i]
                          let s = {}
                          // let dataBD = rs.filter(el => { return parseInt(el.fieldId) === parseInt(d.fieldId) })
                          // console.log('dataBD', dataBD)
                          // if (dataBD.length > 0) {
                          s.bookNo = item.bookNo
                          s.bookingFieldId = dataBookingField[0].bookingFieldId
                          s.bookingDataId = 'newDataBooking'
                          s.conditionField = d.conditionField
                          s.fieldId = d.fieldId
                          s.fieldType = d.fieldType
                          s.fieldValue = s.fieldType === 'Checkbox' ? '[]' : ''
                          s.fieldName = d.fieldName
                          s.conditionField = d.conditionField
                          s.conditionValue = d.conditionValue
                          s.requiredField = d.requiredField
                          s.optionField = d.optionField
                          this.BookingDataItemEdit.push(s)
                        // }
                        }
                      }
                    })
                    .catch(error => {
                      this.$swal(
                        'พบความผิดพลาดระหว่างดำเนินการ',
                        'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
                        'info'
                      )
                        .then(result => {
                          this.internalDialog = false
                        })
                        .catch(error => {
                          console.log('error function setDataEdit : ', error)
                          this.internalDialog = false
                        })
                      console.log('error function setDataEdit : ', error)
                    })
                })
            } else {
              this.$swal(
                'พบความผิดพลาดระหว่างดำเนินการ',
                'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
                'info'
              )
                .then(result => {
                  this.internalDialog = false
                })
                .catch(error => {
                  console.log('error function setDataEdit : ', error)
                  this.internalDialog = false
                })
            }
          })
          .catch(error => {
            this.$swal(
              'พบความผิดพลาดระหว่างดำเนินการ',
              'กรุณากดปุ่มเพื่อดึงข้อมูลใหม่',
              'info'
            )
              .then(result => {
                this.internalDialog = false
              })
              .catch(error => {
                console.log('error function setDataEdit : ', error)
                this.internalDialog = false
              })
            console.log('error function setDataEdit : ', error)
          })
      } catch (error) {
        console.log('error', error)
      }
    },
    async editBooking () {
      this.overlayComponent = true
      await this.$nextTick() // รอให้ overlay render ก่อน
      const isValid = this.$refs.form.validate()
      if (isValid) {
        await this.submitEditBooking()
      } else {
        this.overlayComponent = false
      }
    },
    async submitEditBooking () {
      try {
        this.$swal({
          title: this.languageSelect === 0 ? 'ยืนยันการแก้ไขข้อมูล' : 'Confirm data correction',
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: this.languageSelect === 0 ? 'ใช่' : 'Yes',
          cancelButtonText: this.languageSelect === 0 ? 'ไม่' : 'No'
        }).then(async result => {
          this.overlayComponent = true
          const resUpdateBookingData = await this.updateBookingData()
          this.overlayComponent = false
          if (resUpdateBookingData) {
            this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
            this.pushMsgConfirmEditDataTime()
            this.resetData()
          } else {
            this.$swal(
              'ผิดพลาด',
              'ไม่สามารถแก้ไขข้อมูลได้กรุณาลองใหม่อีกครั้ง',
              'info'
            )
          }
        })
      } catch (error) {
        console.log('error', error)
        this.$swal(
          'ผิดพลาด',
          'ไม่สามารถยกเลิกนัดหมายได้กรุณาลองใหม่อีกครั้ง',
          'info'
        )
      } finally {
        this.overlayComponent = false
      }
    },
    async updateBookingData () {
      try {
        let mapBookingDataItemEdit = this.BookingDataItemEdit
        let payload = []
        let fielditem = this.BookingDataItemEdit
        var fastTrack = 'False'
        var extraJob = 'False'
        for (let i = 0; i < mapBookingDataItemEdit.length; i++) {
          let d = mapBookingDataItemEdit[i]
          let update = {}
          if (d.conditionField === '' || d.conditionField === null) {
            update.fieldId = d.fieldId
            update.bookingDataId = d.bookingDataId
            update.bookingFieldId = d.bookingFieldId
            update.bookNo = d.bookNo
            update.fieldValue = (d.fieldValue || '')
              .replace(/\\/g, '\\\\').replace(/%/g, '%%')
              .replace(/'/g, "\\'")
            update.LAST_USER = this.$session.getAll().data.userName
            update.empSelect = this.formEditBooking.empSelect
            update.fastTrack = fastTrack
            update.extraJob = extraJob
            update.flowId = this.formEditBooking.flowId
            update.masBranchID = this.formEditBooking.masBranchID
            update.shopId = this.$session.getAll().data.shopId
            payload.push(update)
          } else {
            if (
              fielditem.filter(row => {
                return row.fieldId === parseInt(d.conditionField)
              }).length > 0
            ) {
              if (
                d.conditionValue ===
                fielditem.filter(row => {
                  return row.fieldId === parseInt(d.conditionField)
                })[0].fieldValue
              ) {
                update.fieldId = d.fieldId
                update.bookingDataId = d.bookingDataId
                update.bookingFieldId = d.bookingFieldId
                update.bookNo = d.bookNo
                update.fieldValue = (d.fieldValue || '')
                  .replace(/\\/g, '\\\\').replace(/%/g, '%%')
                  .replace(/'/g, "\\'")
                update.LAST_USER = this.$session.getAll().data.userName
                update.empSelect = this.formEditBooking.empSelect
                update.fastTrack = fastTrack
                update.extraJob = extraJob
                update.flowId = this.formEditBooking.flowId
                update.masBranchID = this.formEditBooking.masBranchID
                update.shopId = this.$session.getAll().data.shopId
                payload.push(update)
              }
            } else if (d.conditionField === 'flow') {
              if (
                parseInt(d.conditionValue) === parseInt(this.formEditBooking.flowId)
              ) {
                update.fieldId = d.fieldId
                update.bookingDataId = d.bookingDataId
                update.bookingFieldId = d.bookingFieldId
                update.bookNo = d.bookNo
                update.fieldValue = (d.fieldValue || '')
                  .replace(/\\/g, '\\\\').replace(/%/g, '%%')
                  .replace(/'/g, "\\'")
                update.LAST_USER = this.$session.getAll().data.userName
                update.empSelect = this.formEditBooking.empSelect
                update.fastTrack = fastTrack
                update.extraJob = extraJob
                update.flowId = this.formEditBooking.flowId
                update.masBranchID = this.formEditBooking.masBranchID
                update.shopId = this.$session.getAll().data.shopId
                payload.push(update)
              }
            }
          }
        }
        console.log('payload------------>>>>', payload)
        const response = await axios.post(this.$DNS_IP + '/BookingData/editAdmin', payload)
        if (response.data.status === true) {
          return true
        } else {
          return false
        }
      } catch (error) {
        console.log('error', error)
        return false
      }
    },
    pushMsgConfirmEditDataTime (bookNo) {
      try {
        let dt = {
          dueDateOld: this.dataEditBooking.dueDate,
          flowId: this.formEditBooking.flowId
        }
        axios
          .post(this.$DNS_IP + '/Booking/pushMsgConfirmChamgeTime/' + bookNo, dt)
          .catch(error => {
            console.log('error function addData : ', error)
          })
      } catch (error) {
        console.log('error', error)
      }
    },
    async resetData () {
      await this.$emit('resetData')
      this.internalDialog = false
    }
  }
}
</script>
<style scoped>
.InputData {
  margin: 0px !important;
  padding: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/VelaStudio/DialogEditBooking.vue